var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.765 0C3.03468 0 0 3.03468 0 6.765C0 10.4951 3.03468 13.53 6.765 13.53C10.4951 13.53 13.53 10.4951 13.53 6.765C13.53 3.03468 10.4951 0 6.765 0ZM6.765 12.5937C3.54596 12.5937 0.93632 9.98404 0.93632 6.765C0.93632 3.54596 3.54596 0.93632 6.765 0.93632C9.98404 0.93632 12.5937 3.54596 12.5937 6.765C12.5937 9.98404 9.98404 12.5937 6.765 12.5937Z",
    fill: "#00917D",
    fillOpacity: 0.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36115 3.59494C9.10463 3.38836 8.74977 3.35228 8.45739 3.50276L3.21391 6.1982C2.89733 6.361 2.72287 6.6943 2.76907 7.04762C2.81549 7.40138 3.07025 7.67836 3.41807 7.75426L5.62687 8.2343L6.56803 10.2898C6.71653 10.6134 7.04169 10.8028 7.39677 10.7722C7.75185 10.7419 8.04027 10.5001 8.13157 10.156L9.64451 4.45756C9.72833 4.14032 9.61745 3.80108 9.36115 3.59494ZM7.27775 9.55474L6.29369 7.40578L3.98413 6.90374L8.61337 4.524L7.27775 9.55474Z",
    fill: "#00917D",
    fillOpacity: 0.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/DirectionIcon.811d3a68b49c64004c97fd3c49d4a3f1.svg";
export { ForwardRef as ReactComponent };